import { forwardRef } from 'react';
import Button from '../ui/Button.jsx';

const MiniCard = forwardRef(({ image, text, selected, onClick, button, fn }, ref) => {
    return (
        <div ref={ref} className="relative flex h-[500px] flex-col items-center rounded-2xl px-8 transition-all duration-300">
            <div
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
                className="relative z-10 flex min-h-[300px] w-full cursor-pointer flex-col items-center rounded-2xl border border-white/20 bg-[#FFFFFF14] px-4 py-8 text-center shadow-lg backdrop-blur-md transition-all"
            >
                <div className="mb-4 h-[140px] w-[140px] overflow-hidden rounded-full border-2 border-white/30">
                    <img src={image} alt={text} className="h-full w-full object-cover object-top" />
                </div>

                <p className="text-[20px] font-bold text-white/90">{text}</p>
            </div>

            {selected && button && (
                <div className="absolute inset-0 z-0 -mx-3 -my-8 flex items-end justify-center rounded-3xl bg-cyan-700/70 pb-10">
                    <div className="flex w-full justify-center">
                        <Button {...button} onClick={() => fn.handleAction(button.action)} />
                    </div>
                </div>
            )}
        </div>
    );
});

export default MiniCard;
